
<template>
    <EditorBlock title="What You Get" :block="block">
            <div class="form-group">
                <ul v-if="block.wyg && block.wyg.length" class="list-group mb-1">
                    <li v-for='(item, index) in block.wyg' class="list-group-item d-flex">
                        <div class="align-self-center">{{item}}</div>
                        <div class="align-self-center ml-auto">
                            <a @click.prevent="remove(index, 'wyg')" type='button' class='text-danger'>
                                <font-awesome-icon :icon="['fas', 'times']" />
                            </a>
                        </div>
                    </li>
                </ul>

                <div class="input-group">
                    <input ref="wygInput" type='text' v-model='wygInput' class='form-control' @keydown.enter.prevent="add(wygInput, 'wyg')">
                    <span class="input-group-append">
                        <button @click="add(wygInput, 'wyg')" type='button' class='btn btn-primary' :disabled="!wygInput">Add</button>
                    </span>
                </div>
            </div>

            <div class="form-group mb-0">
                <label>Key Features</label>

                <ul v-if="block.kf && block.kf.length" class="list-group mb-1">
                    <li v-for='(item, index) in block.kf' class="list-group-item d-flex">
                        <div class="align-self-center">{{item}}</div>
                        <div class="align-self-center ml-auto">
                            <a @click.prevent="remove(index, 'kf')" type='button' class='text-danger'>
                                <font-awesome-icon :icon="['fas', 'times']" />
                            </a>
                        </div>
                    </li>
                </ul>

                <div class="input-group">
                    <input ref="kfInput" type='text' v-model='kfInput' class='form-control' @keydown.enter.prevent="add(kfInput, 'kf')">
                    <span class="input-group-append">
                        <button @click="add(kfInput, 'kf')" type='button' class='btn btn-primary' :disabled="!kfInput">Add</button>
                    </span>
                </div>
            </div>
            <div class="form-group">
                <label>Custom Button Label</label>
                <input v-model='block.button_label' class='form-control'>
            </div>
            <div class='form-group'>
                <label>Custom Button HREF</label>
                <input v-model="block.button_uri" class="form-control">
            </div>
    </EditorBlock>
</template>

<style lang="scss" scoped>
    .form-control {
        min-height: 2.5rem;
    }
</style>

<script>
import EditorBlock from "@/components/dashboard/storeadmin/EditorBlock";
export default {
    data: () => ({
        editor: null,
        wygInput: '',
        kfInput: ''
    }),
    props: ['block'],
    components: {
        EditorBlock

    },
    methods: {
        add(text, target) {
            this.block[target].push(text)
            this.$emit('update:block', this.block)
            this.wygInput = ''
            this.kfInput = ''

            this.$refs[target + 'Input'].focus()
        },
        remove(index, target) {
            this.block[target].splice(index,1)
            this.$emit('update:block', this.block)
        }
    },
    mounted () {

    }
}
</script>
